import {IForm} from '@/components/types'
import {useSearchDateShortcut} from "@/hooks/useSearch";

const shortcuts = useSearchDateShortcut()
export const searchFormConfig: IForm = {
  formItems: [
    {
      label: '员工姓名',
      field: 'userId',
      type: 'select',
      filterable: true,
      clearable: true,
      placeholder: '请选择员工'
    },
    {
      field: 'receiveStatus',
      type: 'select',
      label: '领取状态',
      clearable: true,
      filterable: true,
      placeholder: '请选择领取状态',
      options: [
        {title: '未领取', value: '0'},
        {title: '已领取', value: '1'},
      ]
    },
    {
      field: 'createTimeSlot',
      type: 'datepicker',
      label: '中奖时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        },
        shortcuts: shortcuts
      }
    },
    {
      field: 'receiveTimeSlot',
      type: 'datepicker',
      label: '领奖时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        },
        shortcuts: shortcuts
      }
    }
  ]
}
